module.exports = __webpack_public_path__ + "img/02l_marketing.34b26463.jpg";